export default "__VITE_ASSET__CbJMo2a3__"